import { Link } from 'react-router-dom'
import { Calendar, Clock } from 'lucide-react'
import type { UserRsvpEntry } from '@fellowship/shared'
import { EventBadge } from '../ui/EventBadge'
import { formatDate, formatTime } from './format'

interface RsvpRowProps {
  entry: UserRsvpEntry
  /** Past RSVP — dimmed, shows "Attended" instead of the going/maybe pill. */
  past?: boolean
}

export function RsvpRow({ entry, past }: RsvpRowProps) {
  const { occurrence, rsvp, church } = entry
  const title = occurrence.overrideTitle ?? occurrence.event.title

  return (
    <Link to={`/events/${occurrence.event.id}`} style={{ textDecoration: 'none' }}>
      <article
        style={{
          display: 'flex',
          gap: 14,
          alignItems: 'flex-start',
          padding: '14px 16px',
          background: 'var(--surface)',
          border: '1px solid var(--line-soft)',
          borderRadius: 16,
          cursor: 'pointer',
          opacity: past ? 0.65 : 1,
          transition: 'background 0.12s',
        }}
      >
        <div style={{ flexShrink: 0, marginTop: 2 }}>
          <EventBadge type={occurrence.event.eventType} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: 'var(--ink)',
              lineHeight: 1.25,
              marginBottom: 4,
            }}
          >
            {title}
          </div>
          {church && (
            <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 4 }}>{church.name}</div>
          )}
          <div style={{ display: 'flex', gap: 14, fontSize: 12, color: 'var(--ink-2)' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              <Calendar size={11} /> {formatDate(occurrence.startsAt)}
            </span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              <Clock size={11} /> {formatTime(occurrence.startsAt)}
            </span>
          </div>
        </div>
        {past ? (
          <span style={{ flexShrink: 0, fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>Attended</span>
        ) : (
          <span
            style={{
              flexShrink: 0,
              fontSize: 11,
              fontWeight: 700,
              padding: '3px 10px',
              borderRadius: 999,
              background:
                rsvp.attendanceStatus === 'going' ? 'var(--primary-soft)' : 'var(--surface-2)',
              color: rsvp.attendanceStatus === 'going' ? 'var(--primary)' : 'var(--muted)',
            }}
          >
            {rsvp.attendanceStatus === 'going' ? 'Going' : 'Maybe'}
          </span>
        )}
      </article>
    </Link>
  )
}
